import RoundButton from '../components/RoundButton';
import Page from '../components/Page';
import { useAppStore } from '../stores/useAppStore';
import { AnimatePresence, motion } from 'motion/react';
import useMenuNavigation from '../hooks/useMenuNavigation';

function Home() {
  const { content } = useAppStore();
  const navigateTo = useMenuNavigation();

  const items = content?.homepage;

  const handleButtonClick = (key) => {
    navigateTo(key);
  };

  return (
    <Page className='flex overflow-hidden justify-center'>
      <div className='w-[60%] flex flex-wrap gap-x-180u gap-y-100u content-center justify-center overflow-hidden relative'>
        <AnimatePresence>
          {items.map((item, index) => {
            // Si hay 5 elementos, añade margen izquierdo al primero y margen derecho al segundo
            let extraClass = '';
            {/*
            if (items.length === 5) {
              if (index === 0) extraClass = 'ml-400u';
              if (index === 1) extraClass = 'mr-400u';
            }
              */}
            return (
              <RoundButton
                key={item.key}
                index={index}
                color={item.color}
                onClick={() => handleButtonClick(item.key)}
                className={extraClass}
              >
                <div className='
                  flex
                  items-center
                  justify-center
                  content-center
                  flex-col
                  w-full
                  h-full
                  p-20
                  font-extralight
                  text-center
                '>
                  <span className='text-[4.625rem] block leading-[6rem]'>{item.header}</span>
                </div>
              </RoundButton>
            );
          })}
        </AnimatePresence>
      </div>
    </Page>
  );
}

export default Home;